var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Cancel",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    id: "Group",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.732233047,0.732233047 C1.70854378,-0.244077682 3.29145622,-0.244077682 4.26776695,0.732233047 L34.6733585,31.1378246 C35.6496693,32.1141354 35.6496693,33.6970478 34.6733585,34.6733585 C33.6970478,35.6496693 32.1141354,35.6496693 31.1378246,34.6733585 L0.732233047,4.26776695 C-0.244077682,3.29145622 -0.244077682,1.70854378 0.732233047,0.732233047 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.732233047,34.6733585 C1.70854378,35.6496693 3.29145622,35.6496693 4.26776695,34.6733585 L34.6733585,4.26776695 C35.6496693,3.29145622 35.6496693,1.70854378 34.6733585,0.732233047 C33.6970478,-0.244077682 32.1141354,-0.244077682 31.1378246,0.732233047 L0.732233047,31.1378246 C-0.244077682,32.1141354 -0.244077682,33.6970478 0.732233047,34.6733585 Z",
    id: "Rectangle"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.40ef2bf7cdb53726dc67846897b8018c.svg";
export { ForwardRef as ReactComponent };